// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
import { getFont } from '@finect/tabular-utils/getFont';

const SectionTitleBlock = styled.div`
  position: relative;
  ${({ maxWidth }) => maxWidth && 'max-width: 520px; margin: 0 auto;'};
  text-align: center;

  h2 {
    margin-bottom: 12px;
    ${getFont(5, 'compact')};
    font-weight: 700;

    ${maxMediaQueries.miniDesktop`
      ${getFont(4, 'compact')};
    `};

    ${maxMediaQueries.phone`
      ${({ margin }) => (margin ? `margin: ${margin};` : 'margin-bottom: 12px;')};
      ${getFont(3, 'compact')};
    `};
  }

  p {
    ${getFont(1, 'compact')};
    color: ${({ theme }) => theme.colors.fontL};

    ${maxMediaQueries.phablet`
      ${getFont(0)};
    `};
  }

  ${maxMediaQueries.phablet`
    width: 100%;
    max-width: ${grid(4)}px;
    margin: 0 auto;
  `};
`;

type Props = {
  title: string,
  subtitle?: Node,
  noMargin?: boolean,
  maxWidth?: boolean
};

export const SectionTitle = ({ title, subtitle, noMargin, maxWidth }: Props) => (
  <SectionTitleBlock noMargin={noMargin} maxWidth={maxWidth}>
    <h2>{title}</h2>
    <p>{subtitle}</p>
  </SectionTitleBlock>
);
